module.exports = __webpack_public_path__ + "img/upload-img.f9db5d79.svg";